import api from '../../utils/apiFetch';

const path = 'stats';

export default {
  getOrgTransactions: (user) => api.get(`${path}/nonprofittransactions`, user),
};
